<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_main_section") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.section_image')"
            @selectImage="selectImage"
            disabled
          />

          <!-- Start:: Ar Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            disabled
          />
          <!-- End:: Ar Name Input -->

          <!-- Start:: En Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: En Name Input -->

          <!-- Start:: Description Input -->
          <!-- <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.descAr"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.descEn"
            disabled
          /> -->
          <!-- End:: Description Input -->
        </div>
        <!-- Start:: Deactivate Switch Input -->
        <div class="input_wrapper switch_wrapper my-5">
          <v-switch
            color="green"
            :label="
              data.active
                ? $t('PLACEHOLDERS.active')
                : $t('PLACEHOLDERS.notActive')
            "
            v-model="data.active"
            hide-details
            disabled
          ></v-switch>
        </div>
        <!-- End:: Deactivate Switch Input -->
      </form>
    </div>
  </div>
  <!-- END:: Single Step Form Content -->
</template>

<script>
export default {
  name: "CreateArea",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        payment_status: null,
        nameAr: null,
        nameEn: null,
        descAr: null,
        descEn: null,
        type: null,
        paid_amount: null,
        isDiscount: null,
        disCountType: null,
        dis_count_amount: null,
        descEn: null,
        descAr: null,
        is_paid_bollon: null,
        from: null,
        to: null,
        gamesCount: null,
        descEn: null,
        active: true,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    paymentStatus() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.paid"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.unpaid"),
          value: 0,
        },
      ];
    },
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.image.path = res.data.data.data.image;
        this.data.nameAr = res.data.data.data.name_ar;
        this.data.nameEn = res.data.data.data.name_en;

        this.data.descAr = res.data.data.data.description_ar;
        this.data.descEn = res.data.data.data.description_en;

        this.data.type = res.data.data.data.is_paid_text;
        this.data.is_paid_bollon = res.data.data.data.is_paid;
        this.data.paid_amount = res.data.data.data.subscription_price;
        this.data.isDiscount = res.data.data.data.has_discount;
        this.data.disCountType =
          res.data.data.data.discount_type == "fixed"
            ? this.$t("PLACEHOLDERS.value")
            : this.$t("PLACEHOLDERS.presentage");
        this.data.dis_count_amount = res.data.data.data.discount_value;
        this.data.from = res.data.data.data.discount_start_date;
        this.data.to = res.data.data.data.discount_end_date;
        this.data.gamesCount = res.data.data.data.games_count;
        this.data.active = res.data.data.data.is_active;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
